import React from 'react'
import PropTypes from 'prop-types'

import BuyerProfilesWrapper from 'agency/digital_renderer/components/BuyerProfilesWrapper'
import styles from './styles.scss'

const BuyerProfiles = ({ campaign }) => (
  <BuyerProfilesWrapper
    campaign={campaign}
    render={({ buyerProfiles }) => (
      <ul className={styles.root}>{buyerProfiles.map(profile => <li key={profile.key}>{profile.title}</li>)}</ul>
    )}
  />
)

BuyerProfiles.propTypes = {
  campaign: PropTypes.object.isRequired,
}

export default BuyerProfiles
